import { useQuery } from "react-query";
import axios from '../axios';

const useGetRequestTypes = () => {
  const query = useQuery(
    "request-types",
    async () => {
      return await axios.get("/api/request-types"); 
    },
    {
      staleTime: 30000
    }
  )

  return query;
}

export default useGetRequestTypes;